import { IEmailTemplate } from './email-template';

export interface IEmailTemplateResponse {
    data: {
        success: boolean,
        message: string,
        results: IEmailTemplate
    }
}